import { Center, Grid } from '@chakra-ui/react'
import type { ReactNode } from 'react'
import { StatLabel } from './StatLabel'

interface ChartCardProps {
  children: ReactNode
  label: ReactNode
}

export const ChartCard = ({ children, label }: ChartCardProps) => (
  <Grid gap={1}>
    {label && <StatLabel textAlign='center'>{label}</StatLabel>}
    <Center>
      {children}
    </Center>
  </Grid>
)
